import { PageRouteComponent } from './pages/page-route/page-route.component';
import { PageInfoComponent } from './pages/page-info/page-info.component';
import { PageServiceComponent } from './pages/page-service/page-service.component';
import { PageCompanyComponent } from './pages/page-company/page-company.component';
import { PageAddressComponent } from './pages/page-address/page-address.component';
import { RouterModule, Routes } from '@angular/router';



export const routes:Routes = [
		// { path: '', redirectTo: 'itineraire', pathMatch: 'full'},
    { path: 'entreprises', component: PageCompanyComponent },
    { path: "entreprises/:arg", component: PageCompanyComponent },

		{ path: 'info-travaux', component: PageInfoComponent },
    { path: 'adresses', component: PageAddressComponent},
    { path: 'services', component: PageServiceComponent},
    { path: 'itineraire', component: PageRouteComponent},

];

export const routing = RouterModule.forRoot(routes, {
		useHash: true,
		// initialNavigation: false,
    /*enableTracing: true,*/
});


